// Info: Import React Dependancies
import React, { useEffect, useState } from 'react';

// Info: Import NPM Dependancies
import ConditionallyRender from 'react-conditionally-render';
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import rehypeExternalLinks from 'rehype-external-links';
import { useSelector } from 'react-redux';

// Info: Import Local Dependancies
import Loader from '../Loader/Loader';
import '../../assets/css/style.css';
import { callIfExists } from '../Chat/chatUtils';
import { ICustomComponents } from '../../interfaces/IConfig';
import { getChatContent } from '../../store/sitecoreSlice';
import { Button, ButtonGroup, TextArea } from '@enbdleap/react-ui';


interface IChatbotMessageProps {
  message: string;
  withAvatar?: boolean;
  loading?: boolean;
  messages: any[];
  delay?: number;
  id: number;
  setState?: React.Dispatch<React.SetStateAction<any>>;
  customComponents?: ICustomComponents;
  customStyles: { backgroundColor: string };
}
const ChatbotMessage = ({
  message,
  withAvatar = true,
  loading,
  messages,
  customComponents,
  setState,
  customStyles,
  delay,
  id,
}: IChatbotMessageProps) => {
  const [show, toggleShow] = useState(false);
  //const [isFeedBackAvailable, setIsFeedBackAvailable] = useState(false);

  // useEffect(() => {
  //   let timeoutId: any;
  //   const disableLoading = (
  //     messages: any[],
  //     setState?: React.Dispatch<React.SetStateAction<any>>
  //   ) => {
  //     let defaultDisableTime = 750;
  //     if (delay) defaultDisableTime += delay;

  //     timeoutId = setTimeout(() => {
  //       const newMessages = [...messages].map(message => {
  //         if (message.id === id) {
  //           return {...message, loading: false, delay: undefined};
  //         }

  //         return message;
  //       });

  //       setState && setState((state: any) => ({...state, messages: newMessages}));
  //     }, defaultDisableTime);
  //   };

  //   disableLoading(messages, setState);
  //   return () => {
  //     clearTimeout(timeoutId);
  //   };
  // }, [delay, id]);

  useEffect(() => {
    if (delay) {
      setTimeout(() => toggleShow(true), delay);
    } else {
      toggleShow(true);
    }
  }, [delay]);

  const chatBoxCustomStyles = { backgroundColor: '' };
  const arrowCustomStyles = { borderRightColor: '' };

  if (customStyles) {
    chatBoxCustomStyles.backgroundColor = customStyles.backgroundColor;
    arrowCustomStyles.borderRightColor = customStyles.backgroundColor;
  }
  const chatContent = useSelector(getChatContent)
  return (
    <ConditionallyRender
      condition={show}
      show={
        <>
        <div style={{marginBottom:'0'}} className="chatbot-profile-wrapper chatbot-profile-admin">
          
          <ConditionallyRender
            condition={!!customComponents?.botChatMessage}
            show={callIfExists(customComponents?.botChatMessage, {
              message,
              loader: <Loader />,
            })}
            elseShow={
              <>
              
                <ConditionallyRender
                  condition={withAvatar}
                  show={
                    <div className="chatbot-profile-picture">
                      <span>
                      {chatContent?.adminIcon && <img src={chatContent.adminIcon} alt="Chatbot Profile admin" />}
                       
                        </span>                   
                    </div>
                  }
                />
                <ConditionallyRender                 
                  condition={!!loading}
                  show={<Loader />}
                  elseShow={
                    <div className="chatbot-profile-content">
                        <div className="chatbot-profile-title">{chatContent?.adminTitle}</div>
                        <p className="chatbot-profile-chat"> 
                        <ReactMarkdown remarkPlugins={[remarkGfm]}  rehypePlugins={[rehypeRaw, [rehypeExternalLinks, { target: '_blank' }]]} children={String(message)} />
                        {/* <ReactMarkdown remarkPlugins={[remarkGfm]}  rehypePlugins={[rehypeRaw]}>{(message)}</ReactMarkdown> */}
                        </p>

                    </div>
                  }
                />
            </>
            }
          />
        </div>
       
        
        </>

      }
    />
  );
};

export default ChatbotMessage;
